import DocLayout from '../components/docs/DocLayout'
import license from '../../LICENSE.md?raw'

// The license text is read from LICENSE.md at build time, so the page and the
// repository never disagree.
const [heading, ...body] = license.trim().split(/\n\s*\n/)
const blocks = body.map((block) => block.replace(/\s*\n\s*/g, ' '))
const numbered = blocks.filter((block) => /^\d+\.\s/.test(block))
const firstNumbered = blocks.findIndex((block) => /^\d+\.\s/.test(block))

export default function LicensePage() {
  return (
    <DocLayout section={{ label: 'About', to: '/about' }} crumb="License"
      eyebrow="License"
      title={heading.replace(/^#\s*/, '')}
      intro="Mission Design System is licensed to United States government entities under the Protoware License."
    >
      <section className="doc-section doc-license">
        {blocks.map((block, index) => {
          if (index === firstNumbered)
            return (
              <ol key="terms">
                {numbered.map((item) => (
                  <li key={item}>{item.replace(/^\d+\.\s/, '')}</li>
                ))}
              </ol>
            )
          if (/^\d+\.\s/.test(block)) return null
          return <p key={block}>{block}</p>
        })}
      </section>
    </DocLayout>
  )
}
